export enum CanDeactivateResponse {
  Cancel,
  Discard,
  Ok
}
